import { Frequency } from "@/types";
import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { FormCreateFrequency } from "./form-create-frequency";
import { FormUpdateFrequency } from "./form-update-frequency";

type FormFrequencyProps = PropsWithChildren & {
  frequency?: Frequency;
};

export function FormFrequencies({ children, frequency }: FormFrequencyProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={frequency ? "Editar frequência de recebimento" : "Nova frequência de recebimento"}
      description="Cadastro usado nos registros de recebimentos. O intervalo é salvo em dias; não configura a recorrência da agenda ou dos lançamentos financeiros."
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >

      {frequency ? (
        <FormUpdateFrequency
          frequency={frequency}
          handleClose={() => setOpen(false)}
        />
      ) : (
        <FormCreateFrequency handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
